import {
  Box,
  FormControl,
  FormHelperText,
} from '@mui/material';
import RadioGroup from '@mui/material/RadioGroup';
import type { GenericFormField } from 'components/ui/form/GenericForm/index.js';
import {
  Radio,
  RadioFormControlLabel,
} from 'components/ui/form/Radio/index.js';
import type { ChangeEvent } from 'react';
import type {
  Control,
  FieldValues,
} from 'react-hook-form';
import { Controller } from 'react-hook-form';

import {
  StyledFormError,
  StyledFormLabel,
} from './RadioGroupForm.styles.js';

interface RadioGroupFormProps<FormValues extends FieldValues = any> {
  field: GenericFormField;
  transform?: {
    value: (value: unknown) => unknown; onChange: (event: ChangeEvent<HTMLInputElement>) => unknown;
  };
  control: Control<FormValues>;
}

export const RadioGroupForm = ({ control, field, transform }: RadioGroupFormProps) => {
  return (
    <Box {...field?.wrapperProps}>
      <FormControl component="fieldset">
        <Controller
          control={control}
          key={`${field.name}`}
          name={field.name}
          render={({ field: props, fieldState: { error } }) => (
            <>
              {field?.label && (
                <StyledFormLabel required={field?.required}>{field?.label}</StyledFormLabel>
              )}
              {/** We set props.value ?? '' to mark component as controlled, even on initial render when form has undefined props.value */}
              <RadioGroup
                row
                {...props}
                // eslint-disable-next-line no-nested-ternary
                value={props.value !== undefined ? (transform ? transform.value(props.value) : props.value) : ''}
                style={field.inputProps}
                onChange={event => (transform ? props.onChange(transform.onChange(event)) : props.onChange(event))}
              >
                {field.options?.map((option) => {
                  return (
                    <RadioFormControlLabel
                      key={option.value}
                      value={option.value}
                      control={<Radio />}
                      label={option.label}
                      disabled={field.disabled}
                    />
                  );
                })}
              </RadioGroup>
              {error?.message && <StyledFormError>{error.message}</StyledFormError>}
            </>
          )}
        />
      </FormControl>
    </Box>
  );
};
